export function doesArrayHaveObjectWithProp({ array, propName, value }: { array: any[], propName: string, value: number | string | boolean }): boolean {
  let found = false;
  for(let i = 0; i < array.length; i++) {
    if (array[i][propName] === value) {
      found = true;
      break;
    }
  }
  return found;
}
